import { LoginLayout } from '../../components/LoginLayout/LoginLayout';

import { Button, Spacer, Typography } from '@aircall/tractor-v2';
import {
  AIRCALL_AUTHENTICATION_UI_URL,
  AIRCALL_DASHBOARD_URL,
} from '@constants/environment.constants';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SingleLoginPageProps {
  readonly path?: string;
  readonly search?: string;
}

export default function SingleLoginPage({ path = '/', search = '' }: SingleLoginPageProps) {
  const { t } = useTranslation();
  const [isNavigating, setIsNavigating] = useState(false);
  const handleSingleLogin = () => {
    // Disable the button immediately to prevent double-clicks
    setIsNavigating(true);
    const originalUrl = `${AIRCALL_DASHBOARD_URL}${path}${search}`;
    try {
      const url = new URL(originalUrl);
      if (!url.hostname.includes('aircall')) {
        throw new Error('Invalid redirect domain');
      }
    } catch {
      window.location.href = `${AIRCALL_AUTHENTICATION_UI_URL}login?redirect=${encodeURIComponent(
        AIRCALL_DASHBOARD_URL
      )}`;
      return;
    }
    const authUiUrl = `${AIRCALL_AUTHENTICATION_UI_URL}login?redirect=${encodeURIComponent(originalUrl)}`;
    window.location.href = authUiUrl;
  };

  return (
    <LoginLayout data-test='single-login-page'>
      <Spacer direction='vertical' space='xxl' alignItems='center'>
        <Spacer direction='vertical' space='l' alignItems='center'>
          <Typography variant='headingBoldL' textAlign='center'>
            {t('single_login.title', 'Welcome to Aircall')}
          </Typography>
          <Typography variant='bodyRegularM' textAlign='center' color='neutral-600'>
            {t('single_login.subtitle', 'Please sign in to continue to your dashboard')}
          </Typography>
        </Spacer>

        <Button
          variant='primary'
          size='large'
          onClick={handleSingleLogin}
          disabled={isNavigating}
          data-test='single-login-button'
        >
          {t('single_login.button', 'Sign In')}
        </Button>
      </Spacer>
    </LoginLayout>
  );
}
